import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useGroundOverlay } from './useGroundOverlay';
export * from './useGroundOverlay';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    groundOverlay
  } = useGroundOverlay(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    groundOverlay
  }), [groundOverlay]);
  return null;
});